import { useMutation, useQueryClient } from '@tanstack/react-query'

import { notificationApi } from '../api/notificationApi'
import type { NOTIFICATION_TYPE } from '../models/notification.constants'
import { getNotificationQueryOptions } from './useNotificationsQuery'

export const useMarkNotificationAsReadMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number | NOTIFICATION_TYPE) => notificationApi.markAsRead(id),
    onSuccess: () =>
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === getNotificationQueryOptions().queryKey[0],
      }),
  })
}
